import React from 'react';
import { Folder } from 'lucide-react';

export const DemoFolderFilter = ({ value, onChange, scope }) => <label className="inline-flex items-center gap-2 mb-5 text-sm">
  <Folder size={16} className="text-teal-500"/>
  <select aria-label="Resource folder" data-testid={`${scope}-folder-filter`} value={value} onChange={e => onChange(e.target.value)} className="rounded-md border border-gray-400/30 bg-transparent p-2 text-current max-w-full">
    <option value="production">Live workspace</option><option value="demo">Agency Demo Space</option><option value="all">All resources</option>
  </select>
</label>;